import Drawer from '../../../../components/Drawer';
import { StyledWrapper } from './style';

import { useState } from 'react';
import classNames from 'classnames';

export const InfoDrawer = ({ isOpen, onClose, action }) => {
  const [projects, setProjects] = useState([]);

  const [expandedProjects, setExpandedProjects] = useState([]);

  const onExpandProject = id => {
    if (expandedProjects.includes(id)) {
      setExpandedProjects(prev => prev.filter(val => val !== id));
    } else {
      setExpandedProjects(prev => [...prev, id]);
    }
  };

  const onExpandAllProjects = () => {
    if (expandedProjects.length === projects.length) {
      setExpandedProjects([]);
    } else {
      setExpandedProjects(projects.map(item => item.id));
    }
  };

  return (
    <Drawer
      title="Assigned Workflows and Funds"
      open={isOpen}
      onClose={onClose}
      style={{ width: '604px' }}
    >
      <StyledWrapper>
        <div className="funds-container" style={{ marginTop: '20px' }}>
          {isOpen &&
            action?.data?.map(item => {
              return (
                <div className="funds" key={item.workflow_id}>
                  <div className="header">
                    <p> {item.workflow_name}</p>
                  </div>
                  <div className="body">
                    {/* <div className="fund-name">
                      <div style={{ minWidth: '100%' }} className="name">
                        <TbChevronDown onClick={() => onExpandProject(item.workflow_id)} />
                        {item.workflow_name}
                      </div>
                    </div> */}
                    {item.funds.map(fund => (
                      <div className="fund-name" key={fund.fund_id}>
                        <p className="name">{fund.fund_name}</p>
                        <p className={classNames('status', fund.is_approved && 'approved')}>
                          {fund.is_approved ? 'Approved' : 'Pending Approval'}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
        </div>
      </StyledWrapper>
    </Drawer>
  );
};
